import {SmartComponent} from "smart-component-js";

class ViewTrackerComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        params.className = "ViewTrackerComponent";
        super(element, parentComponent, params);

        const entityName = element.dataset.entityName;
        const entityId = element.dataset.entityId;

        if (entityName && entityId) {
            youserxp.ajax(KD_MARANGONI_SITE_CONSTANTS.API_ENDPOINT + `/view/add/${entityName}/${entityId}`, {
                method: 'GET',
            });
        }
    }
}

export default ViewTrackerComponent;